import type React from 'react';
import type { PromoVideo } from '@shared/types/promo-videos';
import { Player } from '@shared/ui';

type Props = {
  video: PromoVideo;
};

export const PromoPlayer: React.FC<Props> = ({ video }) => {
  return <Player video={video} />;
};
